import { createBrowserHistory } from 'history';
import createHashHistory from './hashHistory'
import Globals from 'system/Globals'
// Hash history is the vendored History-API variant in ./hashHistory.js --
// see its header for why (iPadOS 27 reloads the document on location.hash).
const history = Globals.instance().useHashRouter? createHashHistory():createBrowserHistory();
export default history;
